module.exports = __webpack_public_path__ + "img/hassusse.ff244df7.png";